import {
  INTAKE_QUESTION_CODES,
  INTAKE_QUESTION_TYPES,
  yesNoPreferNotToSay,
} from "~/common/utils/consultations/intake";

export const yesNoPreferNotToSayQuestions = {
  [INTAKE_QUESTION_CODES.ai_informant_account]: {
    title:
      "Do you have an account with an AI platform such as ChatGPT or Gemini?",
    subtitle:
      "If you use an AI platform that can reference your chat history, we can ask it to build a summary of your conversations.  You will have a chance to review the summary before deciding to share it.  Even if the summary is imperfect, your reflections on it can be meaningful.",
    type: INTAKE_QUESTION_TYPES.radio,
    options: yesNoPreferNotToSay,
  },
} as const;
